import requests from '../../api/client'
import { HttpAnswer, HttpResult, PurchaseSummaryParams } from '../../types/otp'

export default async function checkoutSummary(
  hash: string
): Promise<HttpResult<PurchaseSummaryParams>> {
  const response = (await requests.checkoutSummary(hash)) as HttpAnswer
  const status = response?.status ?? 200
  const body = (response?.data ?? response) as PurchaseSummaryParams
  return { status, body }
}